import Debug from '@/util/debug';
import isSvg from 'is-svg';
import DOMPurify from 'dompurify';

const debug = Debug('interest-icon');

const safeSvgCache = {};

export default {
  props: {
    url: String,
  },
  data() {
    return {
      safeSvg: '',
    };
  },
  methods: {
    updateSafeSvg() {
      new Promise((resolve, reject) => {
        if (
          !this.url
          || typeof this.url !== 'string'
          || !this.url.endsWith('.svg')
        ) {
          return reject('url must end with .svg');
        }
        return resolve(this.url);
      })
        .then(url => {
          if (Object.prototype.hasOwnProperty.call(safeSvgCache, url)) {
            return Promise.resolve(safeSvgCache[url]);
          }

          // the query param forces new request to s3
          // otherwise you can get cached version without cors headers
          // s3 doesn't send `Vary: Origin` header when you request without 'Origin' header
          // to implement this on s3 side we need cloudfront = $$
          return fetch(`${url}?bypass-s3-header-bug`)
            .then(res => res.text())
            .then(unsafeSvg => {
              if (!isSvg(unsafeSvg)) {
                return Promise.reject('url did not return valid svg');
              }

              return DOMPurify.sanitize(unsafeSvg);
            })
            .then(svg => {
              safeSvgCache[url] = svg;
              return svg;
            });
        })
        .then(svg => this.safeSvg = svg)
        .catch(err => debug.warn('updateSafeSvg error: ', err));
    },
  },
  mounted() {
    this.updateSafeSvg();
  },
  watch: {
    url() {
      this.updateSafeSvg();
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/interest-icon/InterestIcon.js